import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { SpinnerService } from 'app/services/spinner.service';
import { CommonUtilService } from 'app/services/commonUtil.service';
import { AssistenzaService } from 'app/services/assistenza.service';

@Component({
  selector: 'app-create-assistenza',
  templateUrl: './create-assistenza.component.html',
  styleUrls: ['./create-assistenza.component.css'],
})
export class CreateAssistenzaComponent implements OnInit {

  submitted = false;
  error = false;
  file_error = false;
  file_message = '';
  success = false;
  dataJSON: any;
  assistenzaForm: FormGroup;
  uploadedFile: any;
  base64Content: any = null;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private assistenzaService: AssistenzaService,
    private spinner: SpinnerService,
    private commonUtilService: CommonUtilService) {
  }

  ngOnInit() {
    this.spinner.start();

    this.commonUtilService.translateLang("HRWE.PAGE_TITLE.CREATE_ASSISTANZA");

    this.assistenzaForm = this.createAssistenzaFormBuilder(this.formBuilder);

    this.spinner.stop();
  }

  get f() { return this.assistenzaForm.controls; }

  get val() { return this.assistenzaForm.value; }

  createAssistenzaFormBuilder(formBuilder: FormBuilder) {
    return formBuilder.group({
      subject: ['', [Validators.required]],
      message: ['', [Validators.required]],
      attachment: [''],
    });
  }

  onSubmit() {
    this.submitted = true;

    if (this.assistenzaForm.invalid) {
      this.commonUtilService.findInvalidControls(this.assistenzaForm);
      return;
    }
    this.spinner.start();

    this.dataJSON = {
      subject: this.val.subject,
      message: this.val.message,
      attachment: {
        fileName: this.uploadedFile && this.uploadedFile.name ? this.uploadedFile.name : null,
        type: this.uploadedFile && this.uploadedFile.type ? this.uploadedFile.type : null,
        size: this.uploadedFile && this.uploadedFile.size ? this.uploadedFile.size : null,
        extension: this.uploadedFile && this.uploadedFile.name ? this.uploadedFile.name.split('.').pop(): null,
        domain: null,
        userId: null,
        base64: this.base64Content,
        code: null,
        message: null
      },
      threadId: '',
      isParent: ''
    };
    /* console.log(this.dataJSON); */

    this.save(this.dataJSON);

  }

  save(assistenzi): void {
    if (!assistenzi) { return; }
    this.assistenzaService.addAssistenzaParent(assistenzi).subscribe(data => {
      this.success = true;
      this.spinner.stop();
      this.goBack();
    }, err => {
      this.error = true;
      this.spinner.stop();
    });
  }

  goBack() {
    this.router.navigate(['/help']);
  }

  onFileChange(event, field, extension?) {
    const reader = new FileReader();
    if (event.target.files.length > 0) {
      this.file_error = false;
      this.file_message = '';
      this.uploadedFile = event.target.files[0];
      /* console.log(this.uploadedFile);
      console.log("name " + this.uploadedFile.name);
      console.log("type " + this.uploadedFile.type);
      console.log("size " + this.uploadedFile.size);
      console.log("extension " + this.uploadedFile.name.split('.').pop()); */

      if (!extension || this.commonUtilService.enabledExtension(this.uploadedFile, extension)) {
        reader.readAsDataURL(this.uploadedFile);
        reader.onload = () => {
          let kb = this.uploadedFile.size / 1024;
          let mb = kb / 1024;
          let sizeParsed = parseFloat(mb.toString());
          if (sizeParsed > CommonUtilService.LIMIT_SIZE_MB) {
            this.file_error = true;
            this.assistenzaForm.get(field).setValue(undefined);
            return;
          }

          /* console.log("base64 " + this.commonUtilService.getBase64FromFile(reader.result)); */
          this.base64Content = this.commonUtilService.getBase64FromFile(reader.result);
          /* console.log(this.assistenzaForm); */
          this.assistenzaForm.get(field).setValue({
            name: this.uploadedFile.name,
            filetype: this.uploadedFile.type,
            fileBinary: reader.result
          });
        };
      } else {
        this.file_message = CommonUtilService.FILE_BAD_EXTENSION;
        this.file_error = true;
        this.assistenzaForm.get(field).setValue(undefined);
        return;
      }
    }
  }

}
